import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Events from "../components/Events";

const EventsPage = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("events");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {/* Main Content */}
      <main className="pt-16">
        {/* Events Section */}
        <Events />
      </main>

      {/* Footer */}
      <Footer
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
    </div>
  );
};

export default EventsPage;
